// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"299":"77c40cd4","715":"fc5eda4c"}[chunkId] + ".chunk.js";
};